import React, { Fragment } from 'react';
import Stock from '../Stock/Stock';
import CartGridDeliveryDate from '../CartGrid/CartGridDeliveryDate';
import CartGridError from '../CartGrid/CartGridError';
import CartGridItemDetails from '../CartGrid/CartGridItemDetails';
import LoaderInlineContent from '../LoaderInlineContent';
import { currencyFormat, numberFormat } from '../../Services/formatting';
import { translate } from '../../Services/translation';
import SpecificationDetails from '../SpecificationDetails/SpecificationDetails';
import ProductTags from '../ProductTags'

const CartGridItem = ({
  children,
  item,
  inactive,
  loading,
  showWeightColumn = true,
  showStockColumn = true,
  showDeliveryDateColumn = true,
  showSpecDeleteBtn = true,
  showPricePerUnitColumn = true,
  showQuantityColumn = true,
}) => {
  let before, after;

  if (children) {
    React.Children.toArray(children).forEach((child) => {
      if (child.type === Before) {
        before = child;
      } else if (child.type === After) {
        after = child;
      }
    });
  }
  
  return (
    <Fragment>
      {item.inventoryLotExist && item.inventoryLotId.length == 0 && item.inventoryLotError && (
        <CartGridError
          heading={translate('cart.product.inventorylot.error')}
          error={item.inventoryLotError}
        />
      )}

      <div
        className={'cart-grid-item' + (inactive ? ' cart-grid-item--inactive' : '') + (item.inventoryLotError ? ' cart-grid-item--error' : '') +
          (item.cartSelections ? ' cart-grid-item--configured' : '')}      >
        {before && <div className='cart-grid-item__before-cell'>{before}</div>}
        <div className='cart-grid-item__image-cell'>
          <ProductTags isEnvironmentalFriendly={item.isEnvironmentalFriendly} isCampaignProduct={item.isCampaignProduct} />
          <img alt={item.name} src={item.image} />
        </div>
        <div className='cart-grid-item__name-cell'>
          <h3 className='cart-grid-item__name'>
            <a href={item.url}>{item.name}</a>
          </h3>
          <CartGridItemDetails item={item} />
        </div>
        {showQuantityColumn &&
          <div className='cart-grid-item__quantity-cell' data-header={translate('cart.amount')}          >
            {numberFormat.format(item.purchasedQuantity) + ' ' + item.purchasedUnit}
          </div>
        }
        {showWeightColumn &&
          <div className='cart-grid-item__weight-cell' data-header={translate('cart.weight')}          >
            {loading ? (<LoaderInlineContent length={8} />) : (numberFormat.format(item.weight) + ' ' + item.weightUnit)}
          </div>
        }
        {showPricePerUnitColumn && (
          <div className='cart-grid-item__price-cell' data-header={translate('cart.amount.perunit')}          >
            {loading ? (<LoaderInlineContent length={8} />) : !item.isConfigured ? (currencyFormat.format(item.axCustomerNetPrice) + '/' + item.purchasedUnit) : ('')}
          </div>
        )}
        {showStockColumn && (
          <div className='cart-grid-item__stock-cell' data-header={translate('cart.income')}          >
            <Stock
              id={item.variantId}
              articleWeight={item.weight}
              articleFactorKg={item.factorKG}
            ></Stock>
          </div>
        )}
        {showDeliveryDateColumn && (
          <div className='cart-grid-item__date-cell' data-header={translate('cart.predelivery')}          >
            <div>
              {loading ? (
                <LoaderInlineContent length={10} />
              ) : (
                <CartGridDeliveryDate
                  usePreferredDeliveryDate={item.usePreferredDeliveryDate}
                  preferredDeliveryDate={item.preferredDeliveryDate}
                  preliminaryDeliveryDate={item.preliminaryDeliveryDate}
                />
              )}
              <div className='cart-grid-item__price'>
                {loading ? (<LoaderInlineContent length={5} />) : (currencyFormat.format(item.totalPrice))}
              </div>
            </div>
          </div>
        )}
        {after && <div className='cart-grid-item__after-cell'>{after}</div>}
      </div>
      {!item.isHideProductPurchase && item.cartSelections && (
        <SpecificationDetails
          item={item}
          inactive={inactive}
          loading={loading}
          showDeleteBtn={showSpecDeleteBtn}
        />
      )}
    </Fragment>
  );
};

const Before = ({ children }) => {
  return <>{children}</>;
};

const After = ({ children }) => {
  return <>{children}</>;
};

CartGridItem.Before = Before;
CartGridItem.After = After;

export default CartGridItem;
